import { Component, Input ,  OnChanges, SimpleChanges,ChangeDetectionStrategy,  AfterViewChecked } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as FileSaver from 'file-saver';
import { GlobalService } from '../global-service.service';


@Component({
    selector: 'app-einschaetzung',
    templateUrl: './einschaetzung.component.html',
    styleUrls: ['../css/pasura.css'],
    standalone: false
})
export class EinschaetzungComponent  implements OnChanges ,  AfterViewChecked{

   @Input() einschaetzung: any;
   @Input() antrag:any;
   
   vorbehaltOrg:string;
   rowGrey=false;
   
  
  	constructor( public globserv: GlobalService, private http:HttpClient)
  	{}
  	
  	
  	ngAfterViewChecked()
  	{
  		//console.log(" ---------------------------------------ngAfterViewChecked-----------------------------------------------");
		this.rowGrey=false;
  	}
  	
   ngOnChanges(changes: SimpleChanges) 
   {
   	if (this.antrag!=undefined)
   	{
    		this.vorbehaltOrg=this.antrag.Vorbehalt;
    	}
   }
   
  
  	saveBemerkung()
  	{
  		var data={"Vorbehalt": this.antrag.Vorbehalt,"Antrag": this.antrag.AntragID};
		var resultData;
  		this.globserv.getBackendData("/v1/saveVorbehalt", data).subscribe(
		result => resultData=result, 
		 	
  					 err => {
  						this.globserv.setPasuraAction({"msg":{"title":"Fehlmeldung","txt":"Fehler beim speichern der Bemerkung"}});	 
  					 	console.log("Error");
	  					console.log(err); 					 				
  					 },
  					 
		       () => {
		       
		       		if(resultData.Status=="OK")
		       		{

		       			this.vorbehaltOrg=this.antrag.Vorbehalt;
		       		
		       		}else{
		       		
							this.globserv.setPasuraAction({"msg":{"title":"Fehlmeldung","txt":"Fehler beim speichern der Bemerkung"}});		       		
		       		}
			}
		       
		);
	
  		
  	}
  	
  	getRowGrey(auto=true)
  	{
  		if (!auto)
  		{
  			this.rowGrey=false;
  			
  		}else{
  			
			this.rowGrey=!this.rowGrey;
		}
		return this.rowGrey;  	
  	}
  	
  

            
            
  getEinschaetzungPDF(id)
  {
		var data= {};
				
		try {
      	this.globserv.progressSpinner=true;
      	
      	
      
      	this.http.post("/api/v1/getEinschaetzungPDF?id=" +id, data, { responseType: 'blob'  })
            .subscribe((response: any) => {
            	 
            	 var fileName = "Einschaetzung_" +  id + ".pdf";
                FileSaver.saveAs(response, fileName);
                this.globserv.progressSpinner=false;
          });  
         
      	 //this.globserv.progressSpinner=false;
  		} catch (e) {
  		
  		   this.globserv.progressSpinner=false;
				
      	console.log(e);
  		}
			
  }
  
  	
  async getEinschaetzungPDF_(id)
  {
		var data= {};
				
		try {
      	this.globserv.progressSpinner=true;
      
      	this.downloadFile(await this.http.post("/api/v1/getEinschaetzungPDF?id="+id, data, {responseType: 'blob' }).toPromise());
      	
  		} catch (e) {
  		
  		   this.globserv.progressSpinner=true;
				
      	console.log(e);
  		}
			
  }
  
  
  	downloadFile(data) 
	{
		  this.globserv.progressSpinner=false;
        const url = window.URL.createObjectURL(data);
        console.log(JSON.stringify(this.globserv.Settings));
        window.open(url);
  	}
  	
  	getNumber(cm)
  	{
		return Number(cm);  	
  	} 

}
